// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1qod2","item":"Menu_item__2M1fU","link":"Menu_link__1EuRf","active":"Menu_active__3nZjj"};